(function(){
  var GALLERIES={
    jug5:[
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/CopyofShopifyProductImages_1.png?v=1783906123',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/SingleJug-Copy.jpg?v=1783045754',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947'
    ],
    kit10:[
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/10.jpg?v=1786663592',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/1_jug_in_front_of_door.png?v=1787510610',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
    ],
    kit20:[
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/11.jpg?v=1786663592',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/2_jugs_in_front_of_door.png?v=1787510610',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
    ],
    kit30:[
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/12.jpg?v=1786663592',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/3_jugs_in_front_of_door.png?v=1787510610',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
    ]
  };

  function preserveScroll(action){
    var root=document.getElementById('clore-ember-kit-quiz'),top=root?root.scrollTop:0;
    action();
    if(root){
      root.scrollTop=top;
      requestAnimationFrame(function(){root.scrollTop=top;});
    }
  }

  function saveResultState(patch){
    try{
      var saved=JSON.parse(localStorage.getItem('cloreKitQuizState')||'{}');
      Object.keys(patch).forEach(function(key){saved[key]=patch[key];});
      saved.updatedAt=Date.now();
      localStorage.setItem('cloreKitQuizState',JSON.stringify(saved));
    }catch(e){}
  }

  function alignDefendHeroHeadline(){
    var heading=document.querySelector('#clore-lovable-port.clore-defend-only .clore-ember-hero h1');
    var verification=document.querySelector('#clore-lovable-port.clore-defend-only .clore-ember-hero ul li p:last-child');
    if(!heading&&!verification)return;
    var properties=['width','max-width','margin-left','margin-right','align-self','text-align'];
    if(window.matchMedia('(min-width: 1024px)').matches){
      if(heading){
        heading.style.setProperty('width','max-content','important');
        heading.style.setProperty('max-width','none','important');
        heading.style.setProperty('margin-left','0','important');
        heading.style.setProperty('margin-right','0','important');
        heading.style.setProperty('align-self','center','important');
        heading.style.setProperty('text-align','center','important');
      }
      if(verification){
        verification.style.setProperty('font-size','11.43px','important');
        verification.style.setProperty('line-height','1.25','important');
      }
    }else{
      if(heading)properties.forEach(function(property){heading.style.removeProperty(property);});
      if(verification){
        verification.style.removeProperty('font-size');
        verification.style.removeProperty('line-height');
      }
    }
  }

  function textHeading(stage,text){
    return Array.from(stage.querySelectorAll('h3')).find(function(heading){return heading.textContent.trim()===text;});
  }

  function enhance(){
    var stage=document.querySelector('#clore-ember-kit-quiz [data-clore-kit-quiz-stage]');
    if(!stage||!stage.querySelector('h1')||stage.querySelector('h1').textContent.indexOf('Based on Your Answers')<0)return;
    var grid=stage.querySelector('.grid.gap-5');
    if(!grid)return;

    var oldTreatmentHeading=textHeading(stage,"Customized treatment for your home's vulnerabilities");
    var treatmentHeading=oldTreatmentHeading||textHeading(stage,'We identified these vulnerabilities to wildfires')||textHeading(stage,'Your wildfire vulnerabilities');
    var treatmentCard=treatmentHeading&&treatmentHeading.closest('.clore-quiz-card');
    if(treatmentHeading&&treatmentHeading.textContent.trim()!=='Your wildfire vulnerabilities')treatmentHeading.textContent='Your wildfire vulnerabilities';
    if(treatmentCard){
      treatmentCard.classList.remove('order-2','md:order-none');
      treatmentCard.classList.add('order-1','md:col-span-2');
      treatmentCard.style.order='-1';
      treatmentCard.style.gridColumn='1 / -1';
      if(grid.firstElementChild!==treatmentCard)grid.insertBefore(treatmentCard,grid.firstElementChild);
    }

    var galleryButton=stage.querySelector('[data-img-prev]');
    var kitCard=galleryButton&&galleryButton.closest('.clore-quiz-card');
    if(kitCard){
      kitCard.classList.remove('order-1');
      kitCard.classList.add('order-2');
      var inner=kitCard.querySelector('.clore-quiz-card__inner');
      if(inner&&!inner.querySelector('[data-clore-defense-card-header]')){
        var header=document.createElement('div');
        header.className='text-center mb-4';
        header.setAttribute('data-clore-defense-card-header','true');
        header.innerHTML='<span class="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-md bg-deep-forest/10"><svg class="h-4 w-4 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3v8Z"></path><path d="m9 12 2 2 4-4"></path></svg></span><h3 class="font-heading font-extrabold text-deep-forest text-lg">Customized defense for your home</h3>';
        inner.insertBefore(header,inner.firstChild);
      }
    }

    var kitTitle=kitCard&&Array.from(kitCard.querySelectorAll('h3')).find(function(heading){return /5 Gallon Clore Ready to Use Jug/.test(heading.textContent);});
    if(kitTitle){
      var includesHeading=textHeading(stage,'Includes everything you need');
      var includesCard=includesHeading&&includesHeading.closest('.clore-quiz-card');
      if(includesCard)includesCard.querySelectorAll('a').forEach(function(link){if(link.textContent.trim()==='Sprayer Manual PDF')link.remove();});
    }
    stage.querySelectorAll('.clore-quiz-details summary').forEach(function(summary){
      Array.from(summary.childNodes).forEach(function(node){
        if(node.nodeType===3&&node.nodeValue.indexOf('Why These Surfaces Are Treated')>=0)node.nodeValue=node.nodeValue.replace('Why These Surfaces Are Treated','Why These Surfaces Are Sprayed');
      });
    });
    stage.querySelectorAll('.clore-quiz-details-body p').forEach(function(paragraph){
      if(paragraph.textContent.indexOf('Areas beyond 50 feet may still pose a risk but are a lower treatment priority.')>=0){
        paragraph.innerHTML=paragraph.innerHTML.replace('Areas beyond 50 feet may still pose a risk but are a lower treatment priority.','Areas beyond 50 feet may still pose a risk but are a lower protection priority, as per Cal Fire');
      }
    });
    enhanceGallery(stage,kitCard);
    enhanceDelivery(stage);
  }

  function enhanceGallery(stage,kitCard){
    if(!kitCard||kitCard.getAttribute('data-clore-frictionless-gallery')==='true')return;
    var main=kitCard.querySelector('img[alt$="product photo"]'),prev=kitCard.querySelector('[data-img-prev]'),next=kitCard.querySelector('[data-img-next]'),dots=Array.from(kitCard.querySelectorAll('[data-img-dot]'));
    var productHeading=Array.from(kitCard.querySelectorAll('h3')).find(function(heading){return /Gallon/.test(heading.textContent);});
    if(!main||!prev||!next||!productHeading)return;
    var title=productHeading.textContent.trim(),key=/^5 Gallon/.test(title)?'jug5':(/^10 Gallon/.test(title)?'kit10':(/^20 Gallon/.test(title)?'kit20':'kit30'));
    var images=GALLERIES[key]||[],clean=function(url){return String(url||'').split('?')[0]},idx=Math.max(0,images.map(clean).indexOf(clean(main.currentSrc||main.src)));
    if(!images.length)return;
    kitCard.setAttribute('data-clore-frictionless-gallery','true');
    images.forEach(function(src){var preload=new Image();preload.src=src;});
    function show(nextIndex){
      preserveScroll(function(){
        idx=(nextIndex+images.length)%images.length;
        main.src=images[idx];
        dots.forEach(function(dot,i){dot.className='h-1.5 rounded-full transition-all '+(i===idx?'w-4 bg-accent':'w-1.5 bg-silver-sage');dot.setAttribute('aria-current',i===idx?'true':'false');});
        saveResultState({imgIdx:idx});
      });
    }
    function replaceButton(button,attribute,handler){
      var clone=button.cloneNode(true);
      clone.removeAttribute(attribute);
      clone.setAttribute('data-clore-frictionless-control','true');
      button.replaceWith(clone);
      clone.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();handler();clone.blur();});
      return clone;
    }
    replaceButton(prev,'data-img-prev',function(){show(idx-1);});
    replaceButton(next,'data-img-next',function(){show(idx+1);});
    dots=dots.map(function(dot,i){
      var clone=dot.cloneNode(true);
      clone.removeAttribute('data-img-dot');
      clone.setAttribute('data-clore-frictionless-dot',String(i));
      dot.replaceWith(clone);
      clone.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();show(i);clone.blur();});
      return clone;
    });
  }

  function enhanceDelivery(stage){
    var card=stage.querySelector('.clore-quiz-subscription-card');
    if(!card||card.getAttribute('data-clore-frictionless-delivery')==='true')return;
    var oldToggle=card.querySelector('[data-show-delivery-options]'),title=card.querySelector('.clore-quiz-sub-delivery-title'),body=card.querySelector('.clore-quiz-sub-delivery-body');
    if(!oldToggle||!title||!body)return;
    card.setAttribute('data-clore-frictionless-delivery','true');
    var toggle=oldToggle.cloneNode(true),options=document.createElement('div'),mode=/This date/.test(title.textContent)?'date':'april';
    toggle.removeAttribute('data-show-delivery-options');
    toggle.setAttribute('data-clore-frictionless-delivery-toggle','true');
    oldToggle.replaceWith(toggle);
    options.className='space-y-1.5 pt-1 hidden';
    toggle.insertAdjacentElement('afterend',options);
    function updateForms(){
      var root=document.getElementById('clore-ember-kit-quiz'),plan=mode==='date'?'11642863851':'11642896619',label=mode==='date'?'Ships on this date each year':'Ships first week of April each year';
      root.querySelectorAll('[data-clore-quiz-cart-form]').forEach(function(form){
        var purchase=form.querySelector('input[name="properties[Purchase option]"]');
        if(!purchase||purchase.value.indexOf('Subscribe')<0)return;
        var planInput=form.querySelector('input[name="selling_plan"]'),deliveryInput=form.querySelector('input[name="properties[Annual delivery]"]');
        if(planInput){planInput.disabled=false;planInput.value=plan;}
        if(deliveryInput)deliveryInput.value=label;
      });
    }
    function renderOptions(){
      options.innerHTML=['april','date'].map(function(optionMode){var active=optionMode===mode,label=optionMode==='april'?'Ships first week of April each year':'Ships on this date each year';return '<button type="button" data-clore-frictionless-delivery-mode="'+optionMode+'" class="w-full flex items-center gap-2 rounded-lg border px-3 py-1.5 text-left transition-colors '+(active?'border-accent bg-accent/10':'border-silver-sage/50 bg-background hover:border-accent/50')+'"><span class="h-3.5 w-3.5 shrink-0 rounded-full border flex items-center justify-center '+(active?'border-accent':'border-slate-charcoal/40')+'">'+(active?'<span class="h-1.5 w-1.5 rounded-full bg-accent"></span>':'')+'</span><span class="clore-quiz-sub-delivery-option text-sm sm:text-base font-heading font-bold text-slate-charcoal leading-tight">'+label+'</span></button>';}).join('');
      options.querySelectorAll('[data-clore-frictionless-delivery-mode]').forEach(function(button){button.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();preserveScroll(function(){mode=button.getAttribute('data-clore-frictionless-delivery-mode')||'april';title.textContent='Annual delivery: '+(mode==='date'?'This date each year':'Early April, early fire season');body.innerHTML='First order ships immediately<br>Next shipment: '+(mode==='date'?'this date next year':'April 2027');updateForms();saveResultState({delivery:mode});renderOptions();options.classList.add('hidden');});button.blur();});});
    }
    renderOptions();
    toggle.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();preserveScroll(function(){options.classList.toggle('hidden');if(!options.classList.contains('hidden'))renderOptions();});toggle.blur();});
  }

  function init(){
    alignDefendHeroHeadline();
    window.addEventListener('resize',alignDefendHeroHeadline,{passive:true});
    var params=new URLSearchParams(window.location.search||'');
    if(params.get('viewDefendPage')==='1'){
      params.delete('viewDefendPage');
      history.replaceState(history.state,'',window.location.pathname+(params.toString()?'?'+params.toString():'')+window.location.hash);
      var quiz=document.getElementById('clore-ember-kit-quiz');
      if(quiz){quiz.hidden=true;quiz.setAttribute('aria-hidden','true');}
      document.documentElement.classList.remove('clore-kit-quiz-open');
    }
    var stage=document.querySelector('#clore-ember-kit-quiz [data-clore-kit-quiz-stage]');
    if(!stage)return;
    var quizRoot=document.getElementById('clore-ember-kit-quiz');
    if(quizRoot)quizRoot.style.overflowAnchor='none';
    stage.style.overflowAnchor='none';
    new MutationObserver(enhance).observe(stage,{childList:true,subtree:true});
    enhance();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

(function(){
  if(window.__cloreQuizAnalyticsObserverInstalled)return;
  window.__cloreQuizAnalyticsObserverInstalled=true;

  var root=document.getElementById('clore-ember-kit-quiz');
  if(!root)return;
  var STORAGE_KEY='cloreQuizAnalyticsAttempt';

  function newAttempt(){
    var id=['clore_quiz',Date.now(),Math.random().toString(36).slice(2,10)].join('_');
    window.__cloreQuizAttemptId=id;
    try{sessionStorage.setItem(STORAGE_KEY,id);}catch(e){}
    return id;
  }
  function attempt(){
    if(window.__cloreQuizAttemptId)return window.__cloreQuizAttemptId;
    try{window.__cloreQuizAttemptId=sessionStorage.getItem(STORAGE_KEY)||'';}catch(e){}
    return window.__cloreQuizAttemptId||newAttempt();
  }
  function attribution(){
    var params=new URLSearchParams(window.location.search||'');
    return ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid','fbclid'].reduce(function(memo,key){var value=params.get(key);if(value)memo[key]=value;return memo;},{});
  }
  function emit(name,extra){
    var id=attempt(),key=id+':'+name;
    window.__cloreQuizAnalyticsEvents=window.__cloreQuizAnalyticsEvents||{};
    if(window.__cloreQuizAnalyticsEvents[key])return;
    window.__cloreQuizAnalyticsEvents[key]=true;
    var payload=Object.assign({quiz_name:'personal_recommendation',quiz_attempt_id:id,page_path:window.location.pathname,timestamp:new Date().toISOString()},attribution(),extra||{});
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(Object.assign({event:name},payload));
    function gtag(){if(typeof window.gtag!=='function')return false;window.gtag('event',name,Object.assign({},payload));return true;}
    if(!gtag())[500,1500,3000].forEach(function(delay){setTimeout(gtag,delay);});
    function shopify(){if(!window.Shopify||!window.Shopify.analytics||typeof window.Shopify.analytics.publish!=='function')return false;try{var result=window.Shopify.analytics.publish('clore:'+name,payload);if(result&&typeof result.catch==='function')result.catch(function(){});return true;}catch(e){return false;}}
    if(!shopify())[500,1500,3000].forEach(function(delay){setTimeout(shopify,delay);});
  }
  function isResult(){var heading=root.querySelector('[data-clore-kit-quiz-stage] h1');return !!heading&&heading.textContent.indexOf('Based on Your Answers')>=0;}
  function checkCompletion(){if(isResult())emit('clore_quiz_complete');}

  document.addEventListener('click',function(event){
    var target=event.target&&event.target.closest?event.target:null;
    if(!target)return;
    if(target.closest('[data-clore-open-kit-quiz]'))emit('clore_quiz_open',{open_source:'cta'});
    if(target.closest('#clore-ember-kit-quiz [data-patch]'))emit('clore_quiz_start');
    if(target.closest('#clore-ember-kit-quiz [data-clore-kit-quiz-restart]')){
      emit('clore_quiz_restart');
      newAttempt();
      emit('clore_quiz_open',{open_source:'restart'});
    }
  },true);
  document.addEventListener('submit',function(event){
    if(event.target&&event.target.closest&&event.target.closest('#clore-ember-kit-quiz [data-clore-quiz-cart-form]'))emit('clore_quiz_recommendation_add_to_cart');
  },true);
  var stage=root.querySelector('[data-clore-kit-quiz-stage]');
  if(stage)new MutationObserver(checkCompletion).observe(stage,{childList:true,subtree:true});
  checkCompletion();
})();
